import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { LiteralsFacadeService } from 'src/app/shared/services/literals.facade.service';
import { ChatbotFacadeService } from '../../services/chatbot.facade.service';

@Component({
  selector: 'dragonfly-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss'],
  standalone: false,
})
export class ChatbotComponent implements AfterViewInit {
  @ViewChild('chatContainer') chatContainer!: ElementRef<HTMLDivElement>;
  showScrollDownButton = false;
  constructor(
    public facade: ChatbotFacadeService,
    public literalsFacade: LiteralsFacadeService,
  ) {}

  ngAfterViewInit() {
    this.facade.messages$.subscribe(() => {
      this.checkIfScrollable();
    });
  }

  formatTokens(value: number): string {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  createSession(e: any) {
    const message = e.target.value as string;
    if (!this.facade.sessionId && message.length === 1) {
      this.facade.createSession();
    }
    this.facade.typeMessage(message);
  }

  sendQuestion(e: any) {
    const message = e.target.value as string;
    this.facade.sessionId ? this.facade.postQuestion(message) : this.facade.createSessionAndPostQuestion();
  }

  checkIfScrollable() {
    const container = this.chatContainer?.nativeElement;
    if (!container) return;
    const hasScrollbar = container.scrollHeight > container.clientHeight;
    this.showScrollDownButton = hasScrollbar;
  }

  onScroll(container: HTMLElement) {
    const threshold = 100;
    const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight < threshold;
    this.showScrollDownButton = !isAtBottom;
  }

  scrollToBottom(container: HTMLElement) {
    container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
    this.showScrollDownButton = false;
  }
}
